import { Directive, Input, Renderer2, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
    selector: '[tooltip]',
    standalone: false
})
export class MbTooltipDirective implements AfterViewInit {

  @Input() tooltip;
  private readonly viewportMargin = 8;
  private readonly offset = 8;

  constructor(private eRef: ElementRef, private r2: Renderer2) { }

  ngAfterViewInit() {
    const tooltipHost = this.r2.parentNode(this.eRef.nativeElement).querySelectorAll('.' + this.tooltip)[0];
    const tooltip = tooltipHost.firstElementChild as HTMLElement;
    const overlay = tooltipHost.lastElementChild as HTMLElement;

    this.r2.listen(this.eRef.nativeElement, 'click', (e) => {
      if (tooltip.style.display === 'block') {
        tooltip.style.display = 'none';
        overlay.style.display = 'none';
      } else {
        overlay.style.display = 'block';
        tooltip.style.display = 'block';
        this.positionTooltip(tooltip);
      }
    });
  }

  private positionTooltip(tooltip: HTMLElement) {
    const triggerRect = this.eRef.nativeElement.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const preferredTopBelow = triggerRect.bottom + this.offset;
    const preferredTopAbove = triggerRect.top - tooltipRect.height - this.offset;
    const fitsBelow = preferredTopBelow + tooltipRect.height <= window.innerHeight - this.viewportMargin;
    const fitsAbove = preferredTopAbove >= this.viewportMargin;

    const topInViewport = fitsBelow || !fitsAbove
      ? preferredTopBelow
      : preferredTopAbove;
    const maxTopInViewport = Math.max(this.viewportMargin, window.innerHeight - tooltipRect.height - this.viewportMargin);
    const top = Math.min(Math.max(this.viewportMargin, topInViewport), maxTopInViewport);

    const preferredLeftInViewport = triggerRect.right - tooltipRect.width;
    const maxLeftInViewport = Math.max(this.viewportMargin, window.innerWidth - tooltipRect.width - this.viewportMargin);
    const left = Math.min(Math.max(this.viewportMargin, preferredLeftInViewport), maxLeftInViewport);

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
    tooltip.style.right = 'auto';
  }

}
